// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular.json`.

export const environment =
{
  production: false,
  apiUrl: window['settings']["apiUrl"], //radi
  kiApiUrl: window['settings']["kiApiUrl"], //radi
  usersApiUrl: window['settings']["usersApiUrl"],
  rgzApiUrl: window['settings']['rgzApiUrl'],
  tokenExpired: window['settings']["tokenExpired"],
  winAuth: window['settings']["winAuth"],
  enableSSO: window['settings']['enableSSO'],
  ssoConfig: window['settings']['ssoConfig'],
  localStorageKeyForSearchData: window['settings']['localStorageKeyForSearchData'],
  globalnaKompanijaSifra: window['settings']['globalnaKompanijaSifra'],
  sakrijDeoZaPrijavuUsernamePassword: window['settings']['sakrijDeoZaPrijavuUsernamePassword']
};
